import React from 'react'
import Proptypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { toggleProjectDialog } from '../../actions'
import { styled } from '@mui/material/styles'

const classes = {
  container: `new-project-button`,
}
const Container = styled('div')({
  [`&.${classes.container}`]: {
    cursor: 'pointer',
  },
})

const NewProject = () => {
  const dispatch = useDispatch()

  const click = () => {
    dispatch(toggleProjectDialog())
  }

  return (
    <Container className={classes.container} onClick={click}>
      New Project
    </Container>
  )
}
NewProject.propTypes = {
  auth: Proptypes.object,
}
export default NewProject
